// Products offers page handle
(() => {
  const cardStates = new Map();

  function applyCardState(card, productHandle, variantId) {
    const priceWrapper = card.querySelector('.fc-price[data-abra-selector]');
    const addToCartBtn = card.querySelector('.fc-add');
    const variantButtons = card.querySelectorAll('.variant-button');

    if (priceWrapper) {
      priceWrapper.setAttribute('data-product-handle', productHandle);
      priceWrapper.setAttribute('data-variant-id', variantId);
    }

    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-product-handle', productHandle);
      addToCartBtn.setAttribute('data-variant-id', variantId);
    }

    variantButtons.forEach(btn => {
      const btnVariantId = btn.getAttribute('data-variant-id');
      if (btnVariantId === variantId) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function restoreAllCardStates() {
    cardStates.forEach((state, cardElement) => {
      if (document.contains(cardElement)) {
        applyCardState(cardElement, state.productHandle, state.variantId);
      }
    });
  }

  function init() {
    const cards = document.querySelectorAll('.fc-card');

    cards.forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      
      if (!link) return;

      const productUrl = link.getAttribute('href');
      const productHandle = productUrl.split('/products/')[1]?.split('?')[0];

      if (!productHandle) return;

      const activeVariantBtn = card.querySelector('.variant-button.active');
      const initialVariantId = activeVariantBtn ? activeVariantBtn.getAttribute('data-variant-id') : null;

      if (initialVariantId) {
        cardStates.set(card, {
          productHandle,
          variantId: initialVariantId
        });
        applyCardState(card, productHandle, initialVariantId);
      }

      const variantButtons = card.querySelectorAll('.variant-button');

      variantButtons.forEach((btn) => {
        if (btn.dataset.listenerAttached) return;
        btn.dataset.listenerAttached = 'true';

        btn.addEventListener('click', function() {
          const variantId = this.getAttribute('data-variant-id');

          cardStates.set(card, {
            productHandle,
            variantId
          });

          applyCardState(card, productHandle, variantId);

          if (window.Abra && typeof window.Abra.render === 'function') {
            window.Abra.render();
            
            setTimeout(() => {
              restoreAllCardStates();
            }, 50);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Selling plan true/false management
(() => {
  function handlePurchaseOptionChange(radioInput) {
    const isOneTime = radioInput.getAttribute('data-type') === 'one_time';
    
    if (window.Abra && typeof window.Abra.render === 'function') {
      if (isOneTime) {
        window.Abra.useSellingPlanPriceOnProductBlock = false;
      } else {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
      }
      
      window.Abra.render();
    }
  }

  function init() {
    const purchaseOptions = document.querySelectorAll('.sls-option');

    purchaseOptions.forEach((radio) => {
      if (radio.dataset.listenerAttached) return;
      radio.dataset.listenerAttached = 'true';

      radio.addEventListener('change', function() {
        handlePurchaseOptionChange(this);
      });
    });

    const activeOption = document.querySelector('.sls-option:checked');
    if (activeOption) {
      handlePurchaseOptionChange(activeOption);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();